import React from 'react';
import ReactDOM from 'react-dom';
import { Notice } from '../../components/Notice';
var locale = 'en-US';

// Sets a locale variable that controls the locale used for the notice component.
// Since the component is rendered by ReactDOM.render, there is no parent IntlProvider.
// This means we can't use `useIntl` in the Notice and instead need to pass in the locale.
//
// Ideally, in the future we refactor to remove ReactDOM.render and just rely on a store/controller
// to determine if the notice is visible or not.
export function setNoticeLocale(newLocale) {
  locale = newLocale;
}

/**
 * @deprecated Use the new `useShowNotice` hook from @atlassian/proforma-utils instead
 */
export function showNotice(noticeType, intlValues, errorDetails) {
  return new Promise(function (resolve) {
    var dialogTargetNode = document.getElementById('pf-dialog-container');
    if (!dialogTargetNode) {
      // eslint-disable-next-line no-console
      console.error("Could not show notice ".concat(noticeType, ". The target Node for the dialog is not available"));
      resolve(false);
    }
    var handleClose = function handleClose(confirmed) {
      resolve(!!confirmed);
      closeNotice();
    };
    ReactDOM.render( /*#__PURE__*/React.createElement(Notice, {
      noticeType: noticeType,
      handleClose: handleClose,
      settings: {
        intlValues: intlValues,
        errorDetails: errorDetails,
        customLocale: locale
      }
    }), dialogTargetNode);
  });
}
function closeNotice() {
  var dialogTargetNode = document.getElementById('pf-dialog-container');
  if (!dialogTargetNode) {
    // eslint-disable-next-line no-console
    console.error("Could not close notice. The target Node for the dialog is not available");
    return false;
  }
  var closed = ReactDOM.unmountComponentAtNode(dialogTargetNode);
  if (!closed) {
    // eslint-disable-next-line no-console
    console.error("Could not close notice. There is no dialog to unmount");
  }
  return closed;
}